export class SummaryItem {
  constructor (
    public label: string,
    public value?: string,
    public quantity?: number,
    public description?: string,
  ) {}
}
